import React from 'react';
import * as logger from '../../logging/logger';
import { getDetailedError } from '../../common/utils';
import Error from '../pages/Error';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  // static getDerivedStateFromError(error) {
  static getDerivedStateFromError() {
    return { hasError: true };
  }

  async componentDidCatch(error, info) {
    if (typeof (window) !== 'undefined') {
      try {
        const errorDetails = await getDetailedError(error);
        logger.error(
          `Error: in react rendering.\nComponent stack: ${
            info.componentStack
          }.\nCall stack: ${
            errorDetails
          }`
        );
      }
      catch (e) {
        logger.error('React error: unable to provide detailed errors');
      }
    }
    else {
      throw error;
    }
  }

  render() {
    const {
      state,
      props
    } = this;

    if (state.hasError) {
      return <Error code='500' />;
    }

    return props.children;
  }
}

export default ErrorBoundary;